(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-nishitama"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initAboutNishitama(root) {
    if (!root || root.dataset.aboutNishitamaInit === 'true') { return; }
    root.dataset.aboutNishitamaInit = 'true';

    /* ------------------------------------------------------------------
       アニメーション1・3：フェード＆上昇＋同一ブロック内の時間差
       ------------------------------------------------------------------ */
    var groups = root.querySelectorAll('.reveal-group, .reveal');

    if (!('IntersectionObserver' in window) || reduceMotion) {
      each(groups, function (el) { el.classList.add('is-visible'); });
    } else {
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) { return; }
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });

      each(groups, function (el) { revealObserver.observe(el); });
    }

    /* ------------------------------------------------------------------
       アニメーション2：パララックス（中間ブロックの画像のみ）
       ------------------------------------------------------------------ */
    var PARALLAX_RANGE = 24;
    var desktop = window.matchMedia('(min-width: 768px)');
    var targets = [];
    var ticking = false;
    var enabled = false;

    function updateParallax() {
      ticking = false;
      var vh = window.innerHeight;
      targets.forEach(function (el) {
        var frame = el.parentNode;
        if (!frame) { return; }
        var rect = frame.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) { return; }
        var progress = (rect.top + rect.height / 2 - vh / 2) / ((vh + rect.height) / 2);
        progress = Math.max(-1, Math.min(1, progress));
        el.style.transform = 'translate3d(0, ' + (progress * PARALLAX_RANGE).toFixed(1) + 'px, 0)';
      });
    }

    function onScroll() {
      if (ticking) { return; }
      ticking = true;
      window.requestAnimationFrame(updateParallax);
    }

    function enableParallax() {
      if (enabled) { return; }
      targets = Array.prototype.slice.call(root.querySelectorAll('.media--parallax img, .media--parallax .placeholder-svg'));
      if (!targets.length) { return; }
      enabled = true;
      root.classList.add('is-parallax');
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      updateParallax();
    }

    function disableParallax() {
      if (!enabled) { return; }
      enabled = false;
      root.classList.remove('is-parallax');
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      targets.forEach(function (el) { el.style.transform = ''; });
    }

    function syncParallax() {
      if (desktop.matches && !reduceMotion) { enableParallax(); } else { disableParallax(); }
    }

    if (window.requestAnimationFrame) {
      syncParallax();
      if (desktop.addEventListener) {
        desktop.addEventListener('change', syncParallax);
      } else if (desktop.addListener) {
        desktop.addListener(syncParallax);
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    each(document.querySelectorAll('.about-nishitama-section'), initAboutNishitama);
  });

  /* テーマエディタでセクションが再読み込みされた際に再初期化する */
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector ? event.target.querySelector('.about-nishitama-section') : null;
    if (root) { initAboutNishitama(root); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yakikata"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };

  function initTabs(root) {
    if (!root || root.dataset.yakikataTabsInit === 'true') { return; }
    root.dataset.yakikataTabsInit = 'true';

    var buttons = root.querySelectorAll('.yk-tabs__button');
    var panels = root.querySelectorAll('.yk-panel');
    var servingMedia = root.querySelectorAll('[data-serving-media]');

    function activate(key) {
      each(buttons, function (btn) {
        var isActive = btn.getAttribute('data-tab') === key;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      each(panels, function (panel) {
        var isActive = panel.getAttribute('data-panel') === key;
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
      each(servingMedia, function (media) {
        var isActive = media.getAttribute('data-serving-media') === key;
        media.classList.toggle('is-active', isActive);
        if (isActive) {
          media.removeAttribute('hidden');
        } else {
          media.setAttribute('hidden', '');
        }
      });
    }

    each(buttons, function (btn) {
      btn.addEventListener('click', function () {
        activate(btn.getAttribute('data-tab'));
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    each(document.querySelectorAll('.yakikata-section'), initTabs);
  });

  /* テーマエディタでセクションが再読み込みされた際に再初期化する */
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector ? event.target.querySelector('.yakikata-section') : null;
    if (root) { initTabs(root); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
